import type { SchemaBuilderSelectRowProps } from "./schema-builder-select-row.type";

import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";

import { SchemaBuilderConditions } from "../../schema-builder-condition";
import { SchemaBuilderFormListRow } from "../../schema-builder-form-list";
import { SchemaBuilderSelectCopyButton } from "../schema-builder-select-copy-button";

export const SchemaBuilderSelectRow = ({
  formListName,
  field,
  index,
  fieldsLength,
  initialValues,
  onDeleteClick,
}: SchemaBuilderSelectRowProps) => {
  const { t } = useTranslation();
  const missingMessage = t("schema:select.values.missing");

  return (
    <SchemaBuilderFormListRow
      index={index}
      title={t("schema:select.values.label")}
      titleRequired
      deleteText={t("schema:select.delete")}
      deleteDisabled={fieldsLength === 1}
      onDeleteClick={onDeleteClick}
      content={
        <Form.Item
          name={[field.name, "values"]}
          rules={[{ required: true, message: missingMessage }]}
        >
          <Select
            mode="tags"
            tokenSeparators={["\n", "\r"]}
            allowClear
            aria-label={t("schema:select.values.label", { index: index + 1 })}
          />
        </Form.Item>
      }
      actionsAfter={
        <SchemaBuilderSelectCopyButton
          fieldKey={field.key}
          formListName={formListName}
        />
      }
      extra={
        <SchemaBuilderConditions
          name={[field.name, "conditions"]}
          parentName={formListName}
          initialValues={initialValues?.[field.name]?.["conditions"]}
        />
      }
    />
  );
};
